// SSO 專用的 localStorage 工具類別
class ExamineStorage {
    constructor() {
        this.prefix = 'Examine_'; // 唯一前綴，避免與其他網站衝突
    }

    /**
     * 儲存項目到 localStorage
     * @param {string} key - 鍵名
     * @param {any} value - 要儲存的值
     */
    setItem(key, value) {
        try {
            const prefixedKey = this.prefix + key;
            const serializedValue = JSON.stringify(value);
            localStorage.setItem(prefixedKey, serializedValue);
        } catch (error) {
            console.error('Error saving to localStorage:', error);
        }
    }

    /**
     * 從 localStorage 獲取項目
     * @param {string} key - 鍵名
     * @returns {any} 解析後的值，如果不存在則返回 null
     */
    getItem(key) {
        try {
            const prefixedKey = this.prefix + key;
            const item = localStorage.getItem(prefixedKey);
            if (item === null) return null;
            return JSON.parse(item);
        } catch (error) {
            console.error('Error reading from localStorage:', error);
            return null;
        }
    }

    /**
     * 從 localStorage 移除項目
     * @param {string} key - 鍵名
     */
    removeItem(key) {
        try {
            const prefixedKey = this.prefix + key;
            localStorage.removeItem(prefixedKey);
        } catch (error) {
            console.error('Error removing from localStorage:', error);
        }
    }

    /**
     * 清除所有專案相關的 localStorage 項目
     */
    clear() {
        try {
            const keysToRemove = [];
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key && key.startsWith(this.prefix)) {
                    keysToRemove.push(key);
                }
            }
            keysToRemove.forEach(key => localStorage.removeItem(key));
        } catch (error) {
            console.error('Error clearing localStorage:', error);
        }
    }

    /**
     * 取得所有專案相關的 keys
     * @returns {string[]} 不含前綴的 key 陣列
     */
    getProjectKeys() {
        try {
            const projectKeys = [];
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key && key.startsWith(this.prefix)) {
                    projectKeys.push(key.substring(this.prefix.length));
                }
            }
            return projectKeys;
        } catch (error) {
            console.error('Error getting project keys:', error);
            return [];
        }
    }

    /**
     * 檢查項目是否存在
     * @param {string} key - 鍵名
     * @returns {boolean} 是否存在
     */
    hasItem(key) {
        const prefixedKey = this.prefix + key;
        return localStorage.getItem(prefixedKey) !== null;
    }

    /**
     * 取得儲存大小（以字元數計算）
     * @returns {number} 專案相關資料的總字元數
     */
    getSize() {
        try {
            let totalSize = 0;
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key && key.startsWith(this.prefix)) {
                    const value = localStorage.getItem(key);
                    totalSize += key.length + (value ? value.length : 0);
                }
            }
            return totalSize;
        } catch (error) {
            console.error('Error calculating storage size:', error);
            return 0;
        }
    }
}

// 導出單例實例
export default new ExamineStorage();

// 同時導出類別，以便測試或特殊用途
export { ExamineStorage };

// 常用的 storage keys 常數
export const STORAGE_KEYS = {
    TOKEN: 'token',
    USER_INFO: 'UserInfo',
    THEME: 'theme',
    LANGUAGE: 'language',
    DARK_MODE: 'dark',
    TABS: 'tabs',
    SELECTED_TAB: 'selectedTab',
    COMPANY_INFO: 'companyInfo',
    LOGIN_TIME: 'loginTime',
    COMPANY: 'Company',
    // 可以根據需要添加更多 keys
};